module.exports = __webpack_public_path__ + "static/media/footer-image.97a44d48.png";